import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("header", { class: "text-center mb-4" }, [
      _createElementVNode("h2", { class: "skin-page-heading" }, " Understanding your benefit entitlements ")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-12" }, [
        _createElementVNode("p", null, " Many working people are also entitled to benefits. If you are, make sure you are claiming what you are entitled to. This may help you pay some costs and hopefully let you save more into your pension pots to fund retirement. "),
        _createElementVNode("p", null, " Many people currently in retirement are also entitled to benefits. Many of these retirement benefits go unclaimed. You should make sure you claim benefits if you are entitled to them, as they can help support your overall retirement needs. "),
        _createElementVNode("p", null, [
          _createTextVNode(" Like many entities trying to help people understand available benefits, we have teamed up with "),
          _createElementVNode("a", {
            href: "https://inbest.ai",
            target: "_blank"
          }, "Inbest"),
          _createTextVNode(". They provide a great free benefits journey which we have added in our site below. This can help you understand what you may be entitled to, help you save more for retirement, or add some income into your Guiide plan if you have already retired. If you can claim additional income in retirement, just add it into other income in your plan. Give it a try below. ")
        ])
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("iframe", {
          id: "inbest_iframe",
          src: _ctx.inbestSource,
          frameborder: "0",
          width: "100%",
          style: {"height":"1500px"}
        }, null, 8, _hoisted_2)
      ])
    ])
  ], 64))
}